import { SelectionFieldItem } from 'app/area/reports/containers/group-by/types-fields';
import { DrillDownCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';
import { ComplexValue } from 'ui';

export interface StatisticalReportExternalProps {
  drillDown?: DrillDownCallback;
  requestCustomWidth?: (id: number, val: any) => void;
  reflowHandle?: string;
}

export enum ItemTypes {
  AGREGATION_FIELD = 'AGREGATION_FIELD',
  GROUPBY_FIELD = 'GROUPBY_FIELD',
  DISTRIBUTION_FIELD = 'DISTRIBUTION_FIELD',
  TARGET_FIELD = 'TARGET_FIELD',
  GROUPBY_SORT = 'GROUPBY_SORT'
}

export interface SelectItem extends ComplexValue<number | string> {
  allowRollingAverage?: boolean; // property for period selection type
  rollingAverageDescription?: string; // property for period selection type
}

export interface FieldItem extends ComplexValue<number> {
  /**
   * groupId describe id for the same domain fields.
   */
  selected?: boolean;
  showMissingValues?: boolean;
  added?: boolean;
}

export interface FieldValue {
  v?: number;
  d?: string;
  ml?: number;
  allowRollingAverage?: boolean;
  uom?: string;
  children?: FieldValue[];
}

export interface DomainNode {
  domain: number;
  label: string;
  children: DomainNode[];
}

export interface GroupByDomain {
  domain: number;
  label: string;
  showMissingValues: boolean;
  selectionTypes: SelectionTypeResult[];
}

export interface SelectionTypeResult {
  type: FieldValue;
  defaultSelected: boolean;
  maxLevels?: number;
  categories?: FieldValue[];
  periods?: FieldValue[];
}

export interface MetadataResult {
  exposureFactorDefault?: number;
  exposreFactorIncreaseDefault?: number;
}

export interface DragItem {
  field: SelectionFieldItem;
}

export interface DragItemField {
  field: FieldItem;
}
